import { ApiProperty } from "@nestjs/swagger";
import { ItemEnum, PaymentsStatusEnum, PerforationEnum } from "@project-management-system/shared-models";
import { IsNotEmpty, IsOptional, Matches, MaxLength } from "class-validator";

export class PaymentsDTO{
    @ApiProperty()
    @IsNotEmpty({message:"paymentsId should not be empty"})
    @IsOptional()
    paymentsId: number;

    @ApiProperty()
    paymentCode:string;

    @ApiProperty()
    controlNumber:string;

    @ApiProperty()
    materialType:ItemEnum;

    @ApiProperty()
    status:PaymentsStatusEnum.Open;

    @ApiProperty()
    advancePayment:PerforationEnum.NO;
    
    @ApiProperty()
    poId:number;

    @ApiProperty()
    grnId:number;

    @ApiProperty()
    refNo:number;

    @ApiProperty()
    invoiceAmount:number;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message:"Created User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{message:"created user should be only numbers"})
    createdUser :string;

    updatedAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
    updatedUser : string;

    @ApiProperty()
    versionFlag : number;
}